import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const UploadNewDocumentModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.cirrus_white};

  .content {
    width: 100%;
    padding: 24px 16px;

    ${responsive.MOBILE`
          padding: 16px 16px 0 16px;
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
    
        .MuiFormControl-root,
        .MuiTextField-root {
          width: 100%;
          box-sizing: border-box;
        }
        
        &:first-child {
          padding-bottom: 16px;
        }
      
        `}
  }

  .desc-input-box-wrapper {
    margin-top: 40px;
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding-bottom: 24px;

    ${responsive.MOBILE`
      margin-top: 24px;
      grid-template-columns: 1fr;
      width: 100%;
      padding-bottom: 16px;
    `}
    .desc-input {
      .MuiInputBase-root {
        height: 100px;
        background: ${COLORS.cirrus_black1};
        padding: 0px;
      }
    }
  }

  .separator {
    border-bottom: 1px dashed ${COLORS.cirrus_black5};
  }

  .MuiPickersInputBase-root,
  .MuiFormControl-root {
    width: -webkit-fill-available;
  }

  .upload-date {
    background-color: ${COLORS.cirrus_black1};

    .MuiInputBase-root {
      border-radius: 8px;
    }
    .MuiInputAdornment-root {
      opacity: 0.5;
    }
  }

  .MuiFormHelperText-root {
    .error-icon {
      word-break: break-word;
    }
  }
`;
